import type { V2_MetaFunction } from "@remix-run/cloudflare";

// Chakra imports
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  Heading,
  Input,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";

import { useNavigate, useSearchParams } from "@remix-run/react";
import type { FormEvent } from "react";
import { useState } from "react";

export const meta: V2_MetaFunction = () => {
  return [
    { title: "GoTips - Leave tips" },
    {
      name: "description",
      content:
        "GoTips is a service that helps you to leave tips online in a moment, if you don't have a cash.",
    },
  ];
};

export default function Index() {
  // Chakra color mode
  const textColor = useColorModeValue("navy.700", "white");
  const textColorSecondary = "gray.400";
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [code, setCode] = useState("");
  const initialErrorCode = params.get("e");

  const [error, setError] = useState(
    initialErrorCode === "not_found"
      ? "Sorry, but seems your code is incorrect, please check it"
      : ""
  );

  const validate = () => {
    if (!code) {
      return setError("Please, enter the code");
    }

    if (
      !code.startsWith("0") &&
      !code.startsWith("1") &&
      !code.startsWith("2")
    ) {
      return setError("Code should start with 0 or 1 or 2");
    }

    if (code.length === 1) {
      return setError("Code is incorrect, please check it");
    }

    if (error) {
      setError("");
    }

    return true;
  };

  const onSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (!validate()) {
      return false;
    }

    const num = code.slice(1);

    if (code.startsWith("0")) {
      navigate(`/o/${num}`);
    } else if (code.startsWith("1")) {
      navigate(`/p/${num}`);
    } else {
      navigate(`/q/${num}`);
    }
  };

  return (
    <Flex
      // maxW="max-content"
      mx={{ base: "auto", lg: "0px" }}
      me="auto"
      w={{ base: "100%", md: "420px" }}
      justifyContent="center"
      px="10px"
      flexDirection="column"
    >
      <Box me="auto">
        <Heading
          color={textColor}
          fontSize={{ base: "34px", lg: "36px" }}
          mb="10px"
        >
          Leave tips
        </Heading>
        <Text
          mb="24px"
          ms="4px"
          color={textColorSecondary}
          fontWeight="400"
          fontSize="md"
        >
          If you have a code, please enter it below
        </Text>
      </Box>
      <Flex
        zIndex="2"
        direction="column"
        w="100%"
        maxW="100%"
        background="transparent"
        borderRadius="15px"
        mx={{ base: "auto", lg: "unset" }}
        me="auto"
        mb={{ base: "20px", md: "auto" }}
      >
        <form onSubmit={onSubmit}>
          <FormControl mb="24px" isRequired isInvalid={error != ""}>
            <Input
              name="code"
              isRequired={true}
              variant="auth"
              fontSize="xl"
              textAlign="center"
              type="text"
              pattern="\d*"
              placeholder="123456789"
              size="lg"
              value={code}
              onChange={(e) => setCode(e.target.value)}
            />
            <FormErrorMessage>{error}</FormErrorMessage>
          </FormControl>
          <Button
            type="submit"
            variant="brand"
            fontSize="14px"
            fontWeight="500"
            w="100%"
            h="50"
            mb="24px"
          >
            Continue
          </Button>
        </form>
      </Flex>
    </Flex>
  );
}
